<template>
    <div>
        <v-row>
            <v-col cols="12">
                <PletivoVigente @on-select-perlet="onSelectPerlet"/>
            </v-col>
            <v-divider class="my-2"></v-divider>
        </v-row>
        <v-row>
            <v-text-field v-model="search" style="max-width:350px"
                placeholder="Pesquisar material..."
                clearable></v-text-field>
            <v-spacer></v-spacer>
            <v-btn @click="GetCheckListMateriais({ codperlet })"
                :loading="$store.state.checklistdb.loading_id == 'loading-materiais'">
                <v-icon>mdi-refresh</v-icon> &nbsp; Atualizar Materiais
            </v-btn>
        </v-row>
        <v-card variant="outlined">
            <!-- NOVO MATERIAL -->
            <v-card-text>
                <!-- CADASTRAR NOVO MATERIAL -->
                <div >
                    <v-row>
                        <v-col cols="12" sm="6" md="4">
                            <label for="desc_novo_material">
                                <b>Adicionar novo material: </b>
                            </label>
                            <v-text-field hide-details
                                id="desc_novo_material"
                                label="Descrição..."
                                placeholder="Cadastrar Novo Material..."
                                class="mt-1 info--text"
                                v-model="novoMaterial.descricao"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="3">
                            <label for="valor_material">
                                <b>Valor do material:</b>
                            </label>
                            <v-text-field hide-details
                                placeholder="" id="valor_material"
                                label="Valor..."
                                class="mt-1"
                                v-model="novoMaterial.valor"
                                type="number" min="0" max="10000"
                                step="0.10"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2" style="align-self: end; margin-bottom:5px">
                            <v-btn
                                @click="criarNovoMaterial(novoMaterial)"
                                :disabled="!novoMaterial.descricao || !novoMaterial.valor"
                                :loading="$store.state.checklistdb.loading_id == 'create-material'">
                                <v-icon>mdi-plus</v-icon> &nbsp; Adicionar
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>
        </v-card>
        <!-- LISTA DE MATERIAIS CADASTRADOS -->
        <div v-show="computedMateriais.length > 0"
            style="max-height: 500px; overflow-y: auto;padding: 15px 15px 15px 5px !important; white-space: nowrap;">
            <v-table>
                <thead>
                    <tr>
                        <th class="text-left"> Descrição </th>
                        <th width="150" class="text-left"> Valor </th>
                        <th width="150" class="text-right"> Ações </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="m in computedMateriais" :key="m.id">
                        <td>
                            <v-text-field hide-details style="min-width:200px"
                                placeholder="Descrição"
                                v-model="m.descricao">
                                <template v-slot:prepend-inner>
                                    <small class="mx-2 text-disabled">
                                        {{ m.codperlet }}
                                    </small>
                                </template>
                            </v-text-field>
                        </td>
                        <td>
                            <v-text-field hide-details
                                placeholder="15,25"
                                v-model="m.valor"
                                type="number"
                                min="0" max="10000"
                                style="max-width:120px"
                                step="0.10"></v-text-field>
                        </td>
                        <td class="text-right">
                            <v-btn-small icon color="success"
                                @click="UpdateCheckListMaterial(m)"
                                :loading="$store.state.checklistdb.loading_id == m.id">
                                <helper-gdb text="Atualizar"
                                    icon="mdi-content-save"
                                    iconColor="white"/>
                            </v-btn-small>
                            <v-btn-small icon color="error"
                                @click="DeleteCheckListMaterial(m)"
                                :loading="$store.state.checklistdb.loading_id == `delete-${m.id}`">
                                <helper-gdb text="Remover" icon="mdi-delete" iconColor="white"/>
                            </v-btn-small>
                            <loading-gdb :dialog="[`delete-${m.id}`].includes($store.state.checklistdb.loading_id)" :text="'Excluindo '+m.descricao+'...'"/>
                        </td>
                    </tr>
                </tbody>
            </v-table>
            <div v-if="false">
                <div v-for="m, i in computedMateriais" :key="i">
                    <v-row class="mb-4" dense>
                        <v-text-field hide-details style="min-width:200px"
                            placeholder="Descrição" label="Descrição"
                            v-model="m.descricao">
                            <template v-slot:prepend-inner>
                                <small class="mx-2">
                                    {{ m.codperlet }}
                                </small>
                            </template>
                        </v-text-field>
                        <v-text-field hide-details
                            placeholder="Valor"
                            label="Valor"
                            v-model="m.valor"
                            type="number"
                            min="0" max="10000"
                            style="max-width:120px"
                            step="0.10"></v-text-field>
                        <v-btn-small icon color="success"
                            @click="UpdateCheckListMaterial(m)"
                            :loading="$store.state.checklistdb.loading_id == m.id">
                            <helper-gdb text="Atualizar"
                                icon="mdi-content-save"
                                iconColor="white"/>
                        </v-btn-small>
                        <v-btn-small icon color="error"
                            @click="DeleteCheckListMaterial(m)"
                            :loading="$store.state.checklistdb.loading_id == `delete-${m.id}`">
                            <helper-gdb text="Remover" icon="mdi-delete" iconColor="white"/>
                        </v-btn-small>
                        <v-spacer></v-spacer>
                        <loading-gdb :dialog="[`delete-${m.id}`].includes($store.state.checklistdb.loading_id)" :text="'Excluindo '+m.descricao+'...'"/>
                    </v-row>
                </div>
            </div>
        </div>
        <helper-gdb text="Material" v-if="$store.getters.StateAuthenticatedUser.is_superuser"/>
        <loading-gdb :dialog="['loading-materiais'].includes($store.state.checklistdb.loading_id)" text="Carregando materiais..."/>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import PletivoVigente from './PletivoVigente.vue'
export default {
    name: 'CheckListDBMaterialComponent',
    components: {
        PletivoVigente
    },
    data: () => ({
        search: '',
        codperlet: null,
        novoMaterial: {
            descricao: null,
            valor: 0.0
        }
    }),
    mounted() {
        this.init()
    },
    methods: {
        ...mapActions(['GetCheckListMateriais',
                        'UpdateCheckListMaterial',
                        'CreateCheckListMaterial',
                        'DeleteCheckListMaterial']),
        async onSelectPerlet(value){
            this.codperlet = value
            await this.GetCheckListMateriais({codperlet: this.codperlet})
        },
        init(){
            // this.GetCheckListMateriais({codperlet: this.codperlet})
        },
        criarNovoMaterial(m){
            m.codperlet = this.codperlet
            const created = this.CreateCheckListMaterial(m)
            if(!created) return
            // limpar o formulário de material
            const novo = {
                descricao: null,
                valor: 0.0
            }
            this.novoMaterial = Object.assign({}, novo)
        }
    },
    computed: {
        ...mapGetters(['StateCheckListMateriais']),
        computedMateriais(){
            var materiais = this.StateCheckListMateriais
            if (this.search){
                materiais = materiais.filter(o => o.descricao.toLowerCase().indexOf(this.search.toLowerCase()) !== -1)
            }
            return materiais
        }
    }
}
</script>